export default __webpack_public_path__ + "static/media/shapes-2.c00f576a.svg";